<template>
  <div class="after-login">
    <h2 class="form-header">Hello, {{ user.firstName }}</h2>
    <p>
      Aren't you
      <span style="text-decoration: underline">{{user.firstName}} {{user.lastName}}</span>? Click here to
      <a href="#" v-on:click="$emit('logoff')" style="color: #509610">log out</a>.
    </p>
  </div>
</template>
<script>
export default {
  name: "AfterLogin",
  props: ["user"],
};
</script>
<style lang="scss">
$color: #000000;

.after-login {
  color: $color;
  margin-bottom: 30px;
  a {
    color: #509610;
    &:hover {
      color: $color;
    }
  }
}

